<main>
  <div class="fluid-container reg_wrapper">
    <div class="row reg_bg">
      <div class="col-lg-2 col-md-2 hidden-xs"></div>
      <div class="col-lg-4 col-md-4 col-xs-12 reg_left">
        <div>
          <img src="/assets/images/ots_logo.png">
          <p>Welcome {{FirstName}} {{LastName}}</p>
          <span>Please register to create an account with us. It only takes a minute and you only need to do it once. </span>
        </div>
        <div>
          <p class="passwordCondition">
            <br/> When selecting a password, please ensure to:
            <br/> - Choose a new password with 12 or more characters long.
            <br/> - At least one number
            <br/> - At least one special character('!','@', '#', '$', '~')
            <br/> - At least one uppercase letter
            <br/> - Must not be the username</p>
        </div>
      </div>
      <div class="col-lg-1 col-md-1 hidden-xs"></div>
      <div class="col-lg-3 col-md-3 col-xs-12 reg_right">
        <strong class="titleV1">MediaPay Registration</strong>
        <div class="input-field">
          <input [readonly]=true name="FirstName" type="text" class="readOnlyField" placeholder="First Name" [(ngModel)]="FirstName">
        </div>
        <div class="input-field">
          <input [readonly]=true name="LastName" type="text" class="readOnlyField" placeholder="Last Name" [(ngModel)]="LastName">
        </div>
        <div class="input-field">
          <input [readonly]=true name="Email" type="text" class="readOnlyField" placeholder="Email" [(ngModel)]="Email">
        </div>
        <form novalidate name="registeration" #register="ngForm">
          <!-- Password -->
          <div class="input-field">
            <!-- SET 1 -->
            <div *ngIf="!showPassword">
              <div class="addMandatory">
                <input name="NewPassword" appBlockCopyPaste type="password" required [(ngModel)]="Password" placeholder="New Password">
              </div>
              <span *ngIf="Password" (click)="toggleShowPassword()" class="glyphicon glyphicon-eye-open form-control-feedback eye_modify"
                style="cursor: pointer; pointer-events: all;">
        </span>
            </div>
            <!-- SET 2 -->
            <!-- show password as type="text"  -->
            <div [hidden]="!showPassword">
              <div class="addMandatory">
                <input type="text" appBlockCopyPaste name="Password" required [(ngModel)]="Password" placeholder="New Password">
              </div>
              <span *ngIf="Password" (click)="toggleShowPassword()" class="glyphicon glyphicon-eye-close form-control-feedback eye_modify"
                style="cursor: pointer; pointer-events: all;">
        </span>
            </div>
            <div [hidden]="!showPasswordErrorMsg" class="input-ErrorField">Password is required</div>
            <div [hidden]="isPasswordValid" class="input-ErrorField">
              Please enter a valid password
            </div>
            <div [hidden]="isCurrentPasswordHidden" class="input-ErrorField">
              Password should not be your current password
            </div>
          </div>
          <!-- ConfirmPassword -->
          <div class="input-field">
            <div *ngIf="!showConfirmPassword">
              <div class="addMandatory">
                <input name="ConfirmPassword" appBlockCopyPaste type="password" [(ngModel)]="ConfirmPassword" required placeholder="Confirm Password">
              </div>
              <span *ngIf="ConfirmPassword" (click)="toggleShowConfirmPassword()" class="glyphicon glyphicon-eye-open form-control-feedback eye_modify"
                style="cursor: pointer; pointer-events: all;">
        </span>
            </div>
            <!-- SET 2 -->
            <!-- show password as type="text"  -->
            <div *ngIf="showConfirmPassword">
              <div class="addMandatory">
                <input type="text" appBlockCopyPaste name="ConfirmPasswordVisible" required [(ngModel)]="ConfirmPassword" placeholder="Confirm password">
              </div>
              <span *ngIf="ConfirmPassword" (click)="toggleShowConfirmPassword()" class="glyphicon glyphicon-eye-close form-control-feedback eye_modify"
                style="cursor: pointer; pointer-events: all;">
        </span>
            </div>
            <div [hidden]="!showPasswordMatchErrorMsg" class="input-ErrorField">Password does not match</div>
            <div [hidden]="!showConPasswordErrorMsg" class="input-ErrorField">Confirm Password is required</div>
          </div>
          <div class="input-field">
            <div class="addMandatory">
              <input name="Address1" type="text" class="validate" required placeholder="Address1" [(ngModel)]="Address1" maxlength="150">
            </div>
            <div [hidden]="!showAddress1ErrorMsg" class="input-ErrorField">Address1 is required</div>
          </div>
          <div class="input-field">
            <input name="Address2" type="text" placeholder="Address2" [(ngModel)]="Address2">
          </div>     
          <div style="clear:both; padding-top:3px;">
            <div>
              <div class="input-field addMandatory">
                <input name="city" type="text" class="validate" maxlength="40" placeholder="City" [(ngModel)]="City" required>
              </div>
              <div [hidden]="!showCityErrorMsg" class="input-ErrorField">City is required</div>
            </div>
          </div>
          <div>
          <div class="input-field addMandatory">
              <input name="state" type="text" class="validate" maxlength="40" placeholder="State" [(ngModel)]="State" required>
          </div>
          <div [hidden]="!showStateErrorMsg" class="input-ErrorField">State is required</div>
        </div>
        <div>
          <!--   -->
          <div>
              <div class="input-field">
                <div class="addMandatory">
                  <input name="Zipcode" type="text" class="validate" placeholder="Zipcode" pKeyFilter="num" maxlength="8" [(ngModel)]="Zipcode"
                    required>
                </div>
              </div>
              <div [hidden]="!showZipcodeErrorMsg" class="input-ErrorField">Zipcode is required</div>
            </div>  
            
          <div class="addMandatory posAlterCountry" style="margin-top: 20px;">
            <p-autoComplete [(ngModel)]="Country" name="CountryDetail" class="custom-country"
              [suggestions]="filteredCountriesSingle" (completeMethod)="filterCountrySingle($event)" [inputStyle]="{'width':'250px'}"
              [showEmptyMessage]="true" [emptyMessage]="'No Records Found'" [forceSelection]="true"
              optionLabel="countrY_NAME" [appendTo]="'body'" dataKey="CountryID" [size]="100"
              placeholder="Type a Country Name" (clear)="clearValue()" [minLength]="1" [required]="true">
              <ng-template pTemplate="item" let-country>
                {{ country.countrY_NAME }}
              </ng-template>
              <ng-template pTemplate="selectedItem" let-country>
                {{ country.countrY_NAME }}
              </ng-template>
            </p-autoComplete>
            <!-- <p-autoComplete class="custom-country"  placeholderTextColor="black"
             [inputStyle]="{'width':'175px','margin-left':'-5px'}" [(ngModel)]="Country"
            [suggestions]="filteredCountriesSingle" emptyMessage="No Records Found" forceSelection="true"
            (completeMethod)="filterCountrySingle($event)" [size]="50" #agency
            placeholder="Type Agency" name="country" field="countryname" datakey="countryID"
            (onClear)="clearValue()" [minLength]="1">
          </p-autoComplete> -->

          </div>
          <div [hidden]="!showCountyErrorMsg" class="input-ErrorField">Country is required</div>
        </div>    
          
          <!--   -->
          <div style="clear:both;">
            <div class="input-field phoneField">
            <div class="addMandatory">
          <input name="phone1" type="text" [(ngModel)]="Phone1" maxlength="15" pKeyFilter="num" placeholder="Phone1" class="validate addMandatory" required>
        </div>
              <div [hidden]="!showPhone1ErrorMsg" class="input-ErrorField">Phone1 is required</div>
            </div>
            <div class="input-field phoneField phoneField-right">
          <input name="phone2" type="text" [(ngModel)]="Phone2" maxlength="15" pKeyFilter="num" placeholder="Phone2" class="validate">
            </div>
          </div>
          <div class="addMandatory posAlter">
            <p-select [options]="QuestionDetail" name="question" [autoWidth]="false" [style]="{'width':'100%', 'margin-top': '30px'}"
              [(ngModel)]="Question" placeholder="Security Question" appendTo="body" optionLabel="question">
              <ng-template pTemplate="selectedItem" let-selectedOption>
                {{ selectedOption?.question }}
              </ng-template>
              <ng-template pTemplate="item" let-option>
                {{ option.question }}
              </ng-template>
            </p-select>
          </div>
          <div [hidden]="!showQuestionErrorMsg" class="input-ErrorField">Please select a security question</div>
          <div class="input-field">
            <div class="addMandatory">
              <input name="Answer" type="text" class="validate" required placeholder="Answer" [(ngModel)]="Answer" maxlength="50">
            </div>
          </div>
          <div [hidden]="!showAnswerErrorMsg" class="input-ErrorField">Security answer is required</div>
          <!-- <div style="margin-top:15px">
            <re-captcha (resolved)="resolved($event)" siteKey="6Lc7u18UAAAAAIDtZoMML2Vqk7YgTLL20b1xHWny"></re-captcha>
          </div> -->
          <div class="submit_main">
              <!-- [disabled]="isSubmitButtonDisabled" -->
            <button type="button" (click)="Registration($event)" class="reg_submit waves-effect waves-light btn">Submit</button>
            <div class="reg_reset" (click)="register.reset();Resetall();">Reset</div>
          </div>
        </form>
      </div>
      <div class="col-lg-1 col-md-1 hidden-xs"></div>
    </div>
  </div>
</main>